<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image_text_net"><div class="image_text_net"><img alt="e9781783468874_i0003.jpg" src="images/e9781783468874_i0003.jpg"/></div>
<div class="caption"><p class="p">BATTLE AREA Operation <strong class="b">MARKET-GARDEN</strong></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783468874_fm02.vue?5029737a